import { MUNICIPIO } from '../constants/apiRoutes';
import api from './api';


export default {
	findAll() {
		return api.get(MUNICIPIO.FIND_ALL);
	},
	findAllByCrepdec(crepdecId) {
		return api.get(MUNICIPIO.FIND_ALL_BY_CREPDEC.replace('{crepdecId}', crepdecId));
	},
};
